// extracted by mini-css-extract-plugin
export default {"labelWrapper":"labelWrapper---z6R8d"};